export default __webpack_public_path__ + "img/65697c61460c95727ed1fd76990a23a8.svg";